import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Button, Text, Panel, Switch, H3, H4, Dropdown, Fieldset, FormGroup, Radio, Table, Box } from '@bigcommerce/big-design';
import LoadingSpinner from '../partials/LoadingSpinner';
import { AddIcon, ArrowDropDownIcon, DeleteIcon, EditIcon } from '@bigcommerce/big-design-icons';

import { taxSettingsIndex } from '../../redux/actions/taxSettings';

const TaxSettings = ({ payload, settings, submitSettings, loadTaxSettings, taxSettings, setShowNewTaxSettingModal, setActiveTaxSetting, setShowEditTaxSettingModal, setShowDisableTaxSettingModal }) => {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    loadTaxSettings(payload);
  }, []);

  const edit = (id) => {
    let activeTax = taxSettings.taxSettings.find(tax => tax.id === id);
    setActiveTaxSetting(activeTax);
    setShowEditTaxSettingModal(true);
  }

  const disable = (id) => {
    let activeTax = taxSettings.taxSettings.find(tax => tax.id === id);
    setActiveTaxSetting(activeTax);
    setShowDisableTaxSettingModal(true);
  }


  const setDropdownValue = (setField, value) => {
    setField(value);
  }

  const taxSettingsItems = () => {
    let items = [];

    taxSettings.taxSettings.map(taxSetting => 
      items.push(
        {
          content: taxSetting.method_name,
          onItemClick: () => setDropdownValue(setActivePeTaxSetting, taxSetting),
          hash: taxSetting.id
        }
      )
    )

    return items;
  }

  return(
    <Panel>
      <H3>Tax Settings</H3>
      { taxSettings.status !== 'success' &&
        <LoadingSpinner statusText="Loading Tax Settings"/>
      }
      { taxSettings.status === 'success' && taxSettings.taxSettings.length > 0 &&
        <>
          <Table
            columns={[
              { header: 'Name', hash: 'tax_name', render: ({ tax_name }) => tax_name },
              { header: 'Rate (%)', hash: 'rate', render: ({ rate }) => rate },
              { header: 'Code', hash: 'code', render: ({ code }) => code },
              { header: 'Actions', hash: 'id', render: ({ id }) => 
                <>
                  <Button
                    onClick={() => edit(id)}
                    variant="subtle"
                    iconLeft={<EditIcon />}
                  >
                    Edit
                  </Button> 
                  <Button 
                    onClick={() => disable(id)}
                    variant="subtle"
                    actionType="destructive"
                    iconLeft={<DeleteIcon />}
                  >
                    Disable
                  </Button> 
                </>
              },
            ]}
            items={taxSettings.taxSettings}
          />

          <Button
            iconLeft={<AddIcon />}
            onClick={() => setShowNewTaxSettingModal(true)}
            variant="secondary"
          >
            New Tax Setting
          </Button>
        </>
      }
      { taxSettings.status === 'success' && taxSettings.taxSettings.length === 0 &&
        <Box
          backgroundColor="warning10"
          border="box"
          borderRadius="normal"
          padding="medium"
        >
          <div className="text-center">
            <Text>No tax settings set. Create tax settings to see them here.</Text>
            <Button
              iconLeft={<AddIcon />}
              onClick={() => setShowNewTaxSettingModal(true)}
              variant="secondary"
            >
              New Tax Setting
            </Button>
          </div>
        </Box>
      }
    </Panel>
  )
}

const mapStateToProps = state => ({
  settings: state.settings.settings,
  taxSettings: state.taxSettings,
});

const mapDispatchToProps = (dispatch) => ({
  submitSettings: (payload, newSettings) => dispatch(updateSettings(payload, newSettings)),
  loadTaxSettings: (payload) => dispatch(taxSettingsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxSettings);